import moment from "moment";
import { arrayOf, bool, func, number, shape, string } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { push, routerActions } from "react-router-redux";
import {
    actions as transactionLinesActions,
    selectors as transactionLinesSelectors,
} from "reducers/form/transactionLines";
import { selectors as sessionSelectors } from "reducers/session";

import { actions as thirdPaymentActions, selectors as thirdPaymentSelectors } from "reducers/thirdPayment";

import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import PaymentLines from "pages/forms/PaymentLines";

import Button from "pages/_components/Button";
import Notification from "pages/_components/Notification";
import * as accountUtils from "util/accounts";
import * as i18nUtils from "util/i18n";
import * as thirdPaymentUtils from "util/thirdPayment";

import PageLoading from "pages/_components/PageLoading";
import { resizableRoute } from "pages/_components/Resizable";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";

import { Button as CancelButton } from "@ui-kit/components/index.es";
import DownloadButton from "pages/_components/DownloadButton";
import InfoTag from "pages/_components/InfoTag";
import { actions as formActions } from "reducers/form";
import { actions as notificationActions } from "reducers/notification";
import * as configUtils from "util/config";
import Head from "../_components/Head";
import ThirdPaymentCancelData from "./_components/ThirdPaymentCancelData";
import ThirdPaymentSummaryDetail from "./_components/ThirdPaymentSummaryDetail";

class ThirdPaymentDetail extends Component {
    static propTypes = {
        transactionLines: arrayOf(shape({})),
        isConfirmation: bool,
        totalLines: number.isRequired,
        fetchingThirdPayment: bool.isRequired,
        fetchingTransactionLines: bool.isRequired,
        fetchingAccount: bool.isRequired,
        fetchingDownload: bool.isRequired,
        shouldLoadForm: bool,
        dispatch: func.isRequired,
        loggedUser: shape({
            accessToken: string,
            defaultAvatarId: string,
            email: string,
            previousLoginInfo: arrayOf(
                shape({
                    city: string,
                    country: string,
                    date: string,
                    idUser: string,
                    ip: string,
                    latitude: number,
                    longitude: number,
                }),
            ),
        }).isRequired,
        transaction: shape({}),
        isTicket: string,
        match: shape({
            params: shape({}),
        }).isRequired,
        state: shape({}).isRequired,
        location: shape({}).isRequired,

        accounts: shape({}).isRequired,
        activeFilters: shape({}).isRequired,
        embeddedInV3Shell: bool,
        isDesktop: bool,
    };

    static defaultProps = {
        transactionLines: [],
        isConfirmation: false,
        shouldLoadForm: false,
        isTicket: true,
        transaction: null,
        embeddedInV3Shell: false,
        isDesktop: false,
    };

    componentDidMount() {
        const { dispatch, match, loggedUser, activeFilters, location } = this.props;
        dispatch(thirdPaymentActions.getTransaction(match.params.idTransaction, true));
        dispatch(transactionLinesActions.clearTransactionLines());
        const fileId = location?.state?.tr?.data?.file[0]?.fileId;
        const reference = location?.state?.tr?.data?.reference;

        let data = {
            id: match.params.idTransaction,
            pageNumber: 1,
            fileId,
            reference,
        };
        if (activeFilters) {
            data = {
                ...data,
                ...activeFilters,
            };
        }

        dispatch(transactionLinesActions.listTransactionLinesRequest(data));
        dispatch(accountsActions.listAccounts(loggedUser.userId));
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, transaction } = this.props;
        if (
            embeddedInV3Shell &&
            transaction &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
                prevProps.isDesktop !== isDesktop ||
                prevProps.transaction?.id !== transaction?.id ||
                prevProps.transaction?.idTransactionStatus !== transaction?.idTransactionStatus)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { dispatch, match, embeddedInV3Shell } = this.props;
        dispatch(thirdPaymentActions.clearData());
        dispatch(transactionLinesActions.clearTransactionLines());
        dispatch(transactionLinesActions.setPageNumber(0));
        dispatch(thirdPaymentActions.setPageToGoBack(`/payThirdParties/${match.params.idTransaction}/detail`));
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop, transaction, match } = this.props;
        if (!transaction || !match?.params?.idTransaction) {
            return;
        }
        const headerTitle = `${i18nUtils
            .get("payments.thirdPayment.detail.title ")
            .trim()} ${match.params.idTransaction.substring(0, 8).toUpperCase()}`;
        const rightMobile =
            !isDesktop && transaction.idTransactionStatus === "PENDING" ? (
                <Button
                    onClick={this.cancelTransaction}
                    label="thirdPayment.cancel.button"
                    className="btn-outline cmf-button-width"
                />
            ) : (
                undefined
            );
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["forms"],
            headerTitle,
            goBackPath: "/payThirdParties/list",
            rightContentMobile: rightMobile,
        });
    };

    linesToData = (lines, currency) => {
        const id = Date.now();
        return lines.reduce(
            (data, { account, cbu, cuit, creditAmountCurrency, creditAmountQuantity, voucher, motivo, referenc }) =>
                `${data}\n${account},${cbu},${cuit},${creditAmountCurrency},${creditAmountQuantity},
                ${voucher},${motivo},${referenc}`,
            `${id},${currency}`,
        );
    };

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(routerActions.push("/payThirdParties/list"));
    };

    getStatusTransaction = () => {
        const { location } = this.props;
        return thirdPaymentUtils.getThirdPaymentDisplayStatus(location?.state?.tr);
    };

    getTitle = () => {
        const { match, transaction, location } = this.props;
        const transactionStatusName = location?.state?.tr?.transactionStatusName;
        const name = `${i18nUtils.get("payments.thirdPayment.detail.title ")} ${match.params.idTransaction
            .substring(0, 8)
            .toUpperCase()}`;
        let fileName = "";
        const idTransactionStatus = location?.state?.tr?.idTransactionStatus;
        if (transaction !== null) {
            fileName = `${transaction.file[0].fileName}`;
        }
        return (
            <>
                <div className="view-title data-wrapper-flex">
                    <h1 className="my-0 mr-3">{name}</h1>
                    {transaction !== null && (
                        <InfoTag
                            type="info"
                            message={this.getStatusTransaction()}
                            tagBackground={thirdPaymentUtils.statusTagColor(
                                transactionStatusName?.toUpperCase() || idTransactionStatus,
                            )}
                            tagClass="align-self-flex-end"
                            moreStyles={{
                                color: "#072229",
                            }}
                        />
                    )}
                </div>
                <div className="view-title data-wrapper-flex">
                    <span className="data-label">{i18nUtils.get("payments.thirdPayment.detail.fileName")}:</span>
                    <span className="pl-2 data-desc">{fileName}</span>
                </div>
            </>
        );
    };

    isCancellationTimeValid = () => {
        const extractHourStr = configUtils.get("payment.process.hour", "13:00:00");
        const allowedPeriodMin = configUtils.getInteger("frontend.paymentThirdParties.allowedperiod", 30);
        const extractTime = moment(extractHourStr, "HH:mm:ss");
        const deadline = moment(extractTime).subtract(allowedPeriodMin, "minutes");
        return moment().isBefore(deadline);
    };

    cancelTransaction = () => {
        const paymentThirdPartiesFunctionalities = configUtils.getBoolean(
            "frontend.show.paymentThirdParties.functionalities",
            false,
        );
        const { transaction, dispatch, accounts, match, location } = this.props;
        // Validacion de periodo de cancelacion
        if (paymentThirdPartiesFunctionalities && transaction?.idTransactionStatus === "PROCESSING") {
            const canAnular = this.isCancellationTimeValid();
            if (!canAnular) {
                const errorMsj = configUtils.get("frontend.paymentThirdParties.Tooltip.ERROR");
                dispatch(notificationActions.showNotification(errorMsj, "error", "forms"));
                dispatch(routerActions.push("/payThirdParties/list"));
                return;
            }
        }

        let accountName = null;
        const numberAccount = transaction.debitAccount;
        if (accounts.length > 0) {
            const loggedUserAccount = accounts.find((account) => numberAccount.includes(account?.idProduct));
            accountName = accountUtils.getIncomingDebinAccountName(loggedUserAccount);
        }
        const trOrder = location?.state?.tr?.data.processedFileData?.validLines;

        const cancelTransactionData = (
            <ThirdPaymentCancelData
                transactionOrder={trOrder}
                code={thirdPaymentUtils.getCodeMsg(transaction.idTransactionStatus)}
                summary={{
                    data: transaction,
                }}
                accountName={accountName}
            />
        );

        dispatch(push("/transactions/cancel"));
        dispatch(
            formActions.cancelTransactionData({
                idTransaction: match.params.idTransaction,
                content: cancelTransactionData,
                title: "activities.thirdpay.table.menu.decline",
                ...(paymentThirdPartiesFunctionalities &&
                    transaction?.idTransactionStatus === "PROCESSING" && { force: true }),
            }),
        );
        dispatch(formActions.cancelTransactionPre({ idActivity: "pay.multiline.send", idForm: "" }));
        dispatch(thirdPaymentActions.loadConfirmThirdPayment({ ...transaction, action: "cancel" }));
    };

    rightContent = () => (
        <Button
            onClick={this.cancelTransaction}
            label="thirdPayment.cancel.button"
            className="btn-outline cmf-button-width"
        />
    );

    renderPageHeader = () => {
        const { transaction, fetchingDownload, embeddedInV3Shell, isDesktop } = this.props;
        if (embeddedInV3Shell && !isDesktop) {
            return null;
        }
        const paymentThirdPartiesFunctionalities = configUtils.getBoolean(
            "frontend.show.paymentThirdParties.functionalities",
            false,
        );
        return (
            <>
                {transaction !== null && transaction?.idTransactionStatus === "PENDING" && (
                    <>
                        {!embeddedInV3Shell && <Notification scopeToShow="form" />}
                        <div className="admin-detail-head px-0">
                            <Head onBack={this.handleBack} />
                            <Head
                                headerClassName="mb-2"
                                rightContent={this.rightContent}
                                isFetchingExport={false}
                                centerElement={this.getTitle}
                            />
                            {this.renderSubtitle()}
                        </div>
                    </>
                )}
                {transaction !== null && transaction?.idTransactionStatus !== "PENDING" && (
                    <>
                        {!embeddedInV3Shell && <Notification scopeToShow="form" />}
                        <div className="admin-detail-head px-0">
                            <Head onBack={this.handleBack} />
                            <Head
                                headerClassName="mb-2"
                                centerElement={this.getTitle}
                                centerContentClassName="d-flex flex-column align-items-start"
                                rightContent={() => (
                                    <>
                                        {paymentThirdPartiesFunctionalities &&
                                            transaction?.idTransactionStatus === "PROCESSING" && (
                                                <CancelButton
                                                    variant="solid"
                                                    text={i18nUtils.get("thirdPayment.cancel.button")}
                                                    icon="Error"
                                                    iconVariant="outline"
                                                    onClick={() => {
                                                        this.cancelTransaction();
                                                    }}
                                                    w="200px"
                                                />
                                            )}

                                        <DownloadButton
                                            fetching={fetchingDownload}
                                            handleClick={this.handleDownloadClick}
                                            handleClickMessage="global.download"
                                            csvDownload
                                            xlsDownload
                                            imageStyle="mr-2"
                                        />
                                    </>
                                )}
                            />
                            {this.renderSubtitle()}
                        </div>
                    </>
                )}
            </>
        );
    };

    renderSubtitle = () => {
        const { transaction, accounts, location } = this.props;
        const trOrder = location?.state?.tr?.data.processedFileData?.validLines;
        return (
            <>
                {transaction !== null && (
                    <ThirdPaymentSummaryDetail
                        transactionOrder={trOrder}
                        transaction={transaction}
                        accounts={accounts}
                    />
                )}
            </>
        );
    };

    handleDownloadClick = (format) => {
        const { transactionLines, transaction, accounts, dispatch, match, location } = this.props;
        const trOrder = location?.state?.tr?.data.processedFileData?.validLines;

        const { typePayment, file, reference, dateProcess, amount } = transaction;
        const { idTransactionStatus } = location?.state?.tr;

        let accountName = null;

        const numberAccount = transaction?.debitAccount;
        if (numberAccount && accounts.length > 0) {
            const loggedUserAccount = accounts.find((account) => numberAccount.includes(account?.idProduct));
            accountName = accountUtils.getIncomingDebinAccountName(loggedUserAccount);
        }

        const translatedTransactionLines = transactionLines.map((transactionLine) =>
            this.translateStatusTransactionLine(transactionLine),
        );

        dispatch(
            thirdPaymentActions.downloadFileTransaction(
                format,
                translatedTransactionLines,
                typePayment,
                file[0].fileName,
                match.params.idTransaction,
                reference,
                dateProcess,
                trOrder,
                amount?.currency,
                idTransactionStatus,
                accountName,
                this.getStatusTransaction(),
                file[0].fileId,
            ),
        );
    };

    translateStatusTransactionLine = (transactionLine) => ({
        ...transactionLine,
        status: thirdPaymentUtils.statusByState.find(({ value }) => value === transactionLine.status).label,
    });

    renderContent() {
        const { transactionLines, fetchingTransactionLines } = this.props;
        return (
            <>
                <div className="mb-2">{this.renderPageHeader()}</div>
                <PaymentLines
                    totalLines={transactionLines.length}
                    isFetching={fetchingTransactionLines}
                    isTicket
                    {...this.props}
                />
            </>
        );
    }

    render() {
        const { fetchingThirdPayment, fetchingTransactionLines, fetchingAccount } = this.props;

        return (
            <PageLoading loading={fetchingThirdPayment || fetchingTransactionLines || fetchingAccount}>
                {this.renderContent()}
            </PageLoading>
        );
    }
}

const mapStateToProps = (state) => ({
    transaction: thirdPaymentSelectors.getTransaction(state),
    transactionLines: transactionLinesSelectors.getTransactionLines(state),
    accounts: accountsSelectors.getAccounts(state),
    isEditingPayment: transactionLinesSelectors.isEditingPayment(state),
    loggedUser: sessionSelectors.getUser(state),
    fetchingThirdPayment: thirdPaymentSelectors.getFetching(state),
    fetchingAccount: accountsSelectors.getFetching(state),
    fetchingTransactionLines: transactionLinesSelectors.isFetching(state),
    fetchingDownload: thirdPaymentSelectors.getFetchingDownload(state),
    activeFilters: transactionLinesSelectors.getActiveFilters(state),
});

export default compose(connect(mapStateToProps), resizableRoute)(ThirdPaymentDetail);
